// YouTubeShortsGallery.js
import React from "react";

// Extrae el ID del video desde distintas URLs válidas
const getId = (url) => {
  try {
    const u = new URL(url);
    if (u.pathname.startsWith("/shorts/")) {
      return u.pathname.split("/shorts/")[1].split("/")[0];
    }
    if (u.hostname === "youtu.be") {
      return u.pathname.slice(1);
    }
    return u.searchParams.get("v");
  } catch {
    return null;
  }
};

const YouTubeShortsGallery = ({ urls }) => {
  const videoIds = urls.map(getId).filter(Boolean);

  return (
    <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", justifyContent: 'center' }}>
      {videoIds.map((id) => (
        <iframe
          key={id}
          width="100%"
          height="400"
          style={{ maxWidth: "300px", borderRadius: "12px" }}
          src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&playsinline=1`}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={`YouTube Short ${id}`}
        />
      ))}
    </div>
  );
};

export default YouTubeShortsGallery;